import styles from "../styles/About.module.css";

function About() {
  return (
    <section id="about" className={styles.about}>
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.subtitle}>OUR STORY</span>

          <h2>
            More Than a Bar.
            <br />
            An Experience.
          </h2>

          <p>
            KitchenBar combines exceptional food, handcrafted cocktails, and a
            welcoming atmosphere into one unique destination. Whether you're
            joining us for dinner, drinks with friends, or a special occasion,
            every visit is designed to be memorable.
          </p>

          <p>
            From carefully selected ingredients to signature cocktails prepared
            by skilled bartenders, every detail reflects our passion for great
            hospitality and unforgettable evenings.
          </p>

          <div className={styles.stats}>
            <div>
              <h3>100+</h3>
              <span>Signature Drinks</span>
            </div>

            <div>
              <h3>Fresh</h3>
              <span>Quality Ingredients</span>
            </div>

            <div>
              <h3>★★★★★</h3>
              <span>Customer Experience</span>
            </div>
          </div>
        </div>

        <div className={styles.image}>
          <img
            src="https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=900&q=80"
            alt="KitchenBar Interior"
          />
        </div>
      </div>
    </section>
  );
}

export default About;